import { Component } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';
import { flowRight as compose } from 'lodash';

import AxlButton from 'AxlMUIComponent/AxlButton';
import AxlInput from 'AxlMUIComponent/AxlInput';
import JDatePicker from 'components/JDatePicker';
import styles from './styles';

class ShipmentDropoffStatusForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  save = (e) => {
    const { shipmentStore, shipment, dropoff, closeForm } = this.props;
    this.setState({ error: null });
    shipmentStore.updateDropoffStop(
      dropoff,
      () => {
        closeForm();
      },
      (resp) => {
        if (resp.errors && resp.errors.length > 0) {
          this.setState({ error: resp.errors[0] });
        }
      },
    );
  };

  render() {
    const { shipmentStore, dropoff } = this.props;
    const { dropoffStopForm } = shipmentStore;
    const canDiscard = dropoff?.attributes && dropoff.attributes.can_discard === 'true';
    const stopStatuses = [
      { label: 'EN_ROUTE', value: 'EN_ROUTE', color: '#444' },
      { label: 'READY', value: 'READY', color: '#444' },
      { label: 'PENDING', value: 'PENDING', color: '#fa6725' },
      { label: 'SUCCEEDED', value: 'SUCCEEDED', color: '#4abc4e' },
      { label: 'FAILED', value: 'FAILED', color: '#d63031' },
    ].concat(canDiscard ? [{ label: 'DISCARDED', value: 'DISCARDED', color: '#000' }] : []);
    const dropoffStatus = dropoffStopForm.data.status ? { label: dropoffStopForm.data.status, value: dropoffStopForm.data.status } : null;
    const dropoffTimeOptions = {
      dateFormat: 'MMM DD, Y HH:mm:SS A',
      placeHolder: 'Dropoff Time',
      enableTime: true,
      altInput: true,
      clickOpens: true,
      defaultValue: dropoffStopForm.data.actual_departure_ts ? dropoffStopForm.data.actual_departure_ts : null,
    };
    const isSaveValid = dropoffStopForm.getField('remark', '') !== '' && !!dropoffStopForm.data.actual_departure_ts;

    return (
      <div style={styles.Container}>
        <div style={styles.HeaderTitle}>{`Edit dropoff remark`}</div>
        <Box>
          {this.state.error && (
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ flex: 1, ...styles.GroupPanel }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <span style={{ color: 'red', paddingLeft: '15px' }}>{this.state.error}</span>
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1, ...styles.GroupPanel }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Box sx={{ flex: 1 }}>
                  <div style={styles.GroupTitle}>{`Dropoff Status`}</div>
                  <div style={styles.Field}>
                    <Autocomplete
                      value={dropoffStatus}
                      onChange={(_, newValue) => {
                        if (newValue) {
                          dropoffStopForm.handlerReactSelect('status')(newValue);
                        }
                      }}
                      options={stopStatuses}
                      getOptionLabel={(option) => option.label || ''}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Shipment Status" size="small" />
                      )}
                    />
                  </div>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1, ...styles.GroupPanel }}>
              <div style={styles.GroupTitle}>{`Dropoff Time`}</div>
              <div style={styles.GroupField}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <div style={styles.Field}>
                      <JDatePicker onChange={dropoffStopForm.handlerDateInput('actual_departure_ts')} options={dropoffTimeOptions} />
                    </div>
                  </Box>
                </Box>
              </div>
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1, ...styles.GroupPanel }}>
              <div style={styles.GroupTitle}>{`Remark`}</div>
              <div style={styles.GroupField}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Box sx={{ flex: 1 }}>
                    <div style={styles.Field}>
                      <AxlInput
                        value={dropoffStopForm.getField('remark', '')}
                        onChange={dropoffStopForm.handlerInput}
                        placeholder={`Remark`}
                        name={`remark`}
                        type={`text`}
                        fluid
                      />
                    </div>
                  </Box>
                </Box>
              </div>
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                <div style={{ ...styles.Field, ...styles.FieldButton }}>
                  <AxlButton compact bg={`gray`} onClick={this.props.closeForm} style={styles.buttonControl}>{`Cancel`}</AxlButton>
                </div>
                <div style={{ ...styles.Field, ...styles.FieldButton }}>
                  <AxlButton compact bg={`pink`} onClick={this.save} style={styles.buttonControl} disabled={!isSaveValid}>{`Save`}</AxlButton>
                </div>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
    );
  }
}
export default compose(withRouter, inject('store'), observer)(ShipmentDropoffStatusForm);
